export default __webpack_public_path__ + "static/media/fr.78df1f5f.svg";